import { observable } from 'mobx';

export type ConsignmentSaleResponseArgs = {
  name: string;
  company_name: string;
  travel_agency_number: string;
  address: string;
  postcode: string;
};

export type ConsignmentSaleArgs = {
  name: string;
  companyName: string;
  travelAgencyNumber: string;
  address: string;
  postcode: string;
};

export const convertConsignmentSaleResponseToArgs = (response: ConsignmentSaleResponseArgs) => {
  const args: ConsignmentSaleArgs = {
    name: response.name,
    companyName: response.company_name,
    travelAgencyNumber: response.travel_agency_number,
    address: response.address,
    postcode: response.postcode
  };
  return args;
};

export default class ConsignmentSale {
  @observable name: string;
  @observable companyName: string;
  @observable travelAgencyNumber: string;
  @observable address: string;
  @observable postcode: string;

  constructor(args: ConsignmentSaleArgs) {
    this.name = args.name;
    this.companyName = args.companyName;
    this.travelAgencyNumber = args.travelAgencyNumber;
    this.address = args.address;
    this.postcode = args.postcode;
  }
}
